module.exports = __webpack_public_path__ + "static/163-dd0db31ac801cbbc9311706cf54fe3c1.jpg";